import { render, staticRenderFns } from "./PersonEditor.vue?vue&type=template&id=8d822566&"
import script from "./PersonEditor.vue?vue&type=script&lang=js&"
export * from "./PersonEditor.vue?vue&type=script&lang=js&"
import style0 from "./PersonEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports